import styled from "styled-components";
import { scale } from "../utils/typography";

export const StyledHero = styled.section`
  padding-top: 30px;
  background-color: #222 !important;
  color: #fff;

  .image-container {
    width: ${props => props.landscape ? "60%" : "100%"};
  }
  @media (max-width: 768px){
    height ${props => props.landscape ? "0%" : "543px"};
    margin-bottom: ${props => props.landscape ? "0" : "70px"};
  }

  @media (min-width: 568px){
    height: 745px !important:
  }

  @media (min-width: 1024px){
    height: 424px !important;
    margin-bottom: 90px;
  }

  .logo-container{
    display:flex;
    flex-direction: row;
  }

  .logo {
    width: 100%;
  }

  .image-logo {
    margin-left: auto;
    margin-right: auto;
  }

  .captions{
    padding: 0px 5vw;
    color: white;
    text-shadow: rgb(10 10 10) 1px 1px 7px;
  }

  .captions.center{
    place-self: center;
    text-align: left;
  }

  .captions h1.bebas{
    font-size: 4rem;
    line-height: 1 !important;
    font-family: Bebas Neue Bold !important;
  }

  .captions p.bebas{
    font-size: 2rem;
    line-height: 1 !important;
    font-family: Bebas Neue Bold;
  }

  .slogan-container{
    width: 100%;
    display: flex;
    flex-direction: row;
  }

  .slogan {
    width: 66%;

     @media (max-width: 767px){
       margin-bottom: 20px !important;
     }

    @media (min-width: 768px){
      width: 50%;
    }
  }

  .slogan p{
    margin-left: 23px;
    font-size: 20px;
    font-family: 'Roboto' !important;

    @media (max-width: 769px){
      margin-top: -15px;
    }

    @media (min-width: 768px){
      font-size: 26px !important;
    }
  }
`;

export const StyleHeroPc = styled.section`

   .image{
     width: 80%;
     height: 100%;
     margin-left: 10%;

     @media (max-width: 768px){
       width: 100% !important;
     }
   }

   .logo-container{
     width: 100%;
   }

   .logo{
      margin-top: 34px;
      margin-right: 63px;
      margin-bottom: -28px;
   }

   .row {
     width: 100%;
     display: flex;
     flex-direction: row;
   }

   .col {
     width: 50%;
   }

   .col-image{
     width: 60%;
   }

   .col-brand {
     width: 40%;
   }

   .text {
     text-align: right !important;
     text-transform: none;
   }

   .slogan {
     /*width: 409px !important; */
     width: 100%;

     @media (min-width: 768px){
       margin-top: -25px;
       line-height: 25px;
     }


   }
`;
